<template>
  <a-row class="map_container">
      <div id="map"></div>
      <ul>
        <li>
          <div class="map_info_icon">
            <img src="../../assets/icons/map_car_icon.svg" alt="">
          </div>
          <span>{{carStatusText}}</span>{{currentCarStatus.speed}} km/h
        </li>
        <li>
          <div class="map_info_icon">
            <img src="../../assets/icons/map_clock_icon.svg" alt="">
          </div>
          {{currentCarStatus.time}}
        </li>
        <li>
          <div class="map_info_icon">
            <img src="../../assets/icons/map_location_icon.svg" alt="">
          </div>
          {{currentCarStatus.location}}
        </li>
      </ul>
      <button v-if="!hasUpdatedRecord" class="no_record_btn">該車尚無上傳紀錄<br>請將車輛啟動後，再次嘗試</button>
      <button v-if="isExpired" class="expired_btn">服務已到期 (點選此按鈕前往續約)</button>
  </a-row>
</template>

<script>
  import Map from "ol/Map";
  import View from "ol/View";
  import { Tile as TileLayer } from 'ol/layer';
  import { XYZ, Vector } from 'ol/source';
  import { fromLonLat, transformExtent } from 'ol/proj';
  import { GeoJSON } from 'ol/format';
  import Feature from 'ol/Feature';
  import { Point } from 'ol/geom';
  import drivingIcon from "../../assets/icons/car_status_driving.svg";
  import flameoutIcon from "../../assets/icons/car_status_flameout.svg";
  import lostIcon from "../../assets/icons/car_status_lost.svg";
  import idleIcon from "../../assets/icons/car_status_Idle.svg";
  import VectorLayer from 'ol/layer/VectorImage';
  import { Style, Icon } from 'ol/style';
  import { defaults } from "ol/control";
  import { boundingExtent } from 'ol/extent';
  import {defaults as defaultInteractions} from 'ol/interaction'
  // import { io } from "socket.io-client";

  // 圖磚URL
  const url = 'https://wa-hotaiopen.azurewebsites.net/map/npkget.ashx?z={z}&x={x}&y={y}';
  const dafaultPosition = [121.4591572, 25.0601437];
  // 限制地圖可拖拉的範圍界限(因為地圖縮到很小時，超出圖磚範圍的地方會有空白，故限制可拖拉的大概範圍為整個台灣本島)
  const extentBound = boundingExtent([[118.230796, 18.707473], [123.229752, 26.60011]]);
  // 設定圖磚的圖層
  const tileLayer = new TileLayer({
    source: new XYZ({
      url,
    }),
  });
  // 行駛中marker樣式
  const drivingMarkerStyle = new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: drivingIcon,
    }),
  });
  // 熄火marker樣式
  const flameoutMarkerStyle = new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: flameoutIcon,
    }),
  });
  // 失聯marker樣式
  const lostMarkerStyle = new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: lostIcon,
    }),
  });
  // 怠速中marker樣式
  const idleMarkerStyle = new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: idleIcon,
    }),
  });
  // 假資料
  const testData = [
      {
        status: 'noData',
        speed: '--',
        time: '--',
        location: '--',
        coordinate: [121.4591572, 25.0601437],
      },
      {
        status: 'driving',
        speed: '70',
        time: '2021-09-10 13:36',
        location: '北都PDS',
        coordinate: [121.4591572, 25.0591437],
      },
      {
        status: 'idle',
        speed: '0',
        time: '2021-09-10 13:41',
        location: '桃苗PDS',
        coordinate: [121.4591572, 25.0581437],
      },
      {
        status: 'flameout',
        speed: '0',
        time: '2021-09-10 13:46',
        location: '中部PDS',
        coordinate: [121.4591572, 25.0571437],
      },
      {
        status: 'lost',
        speed: '--',
        time: '2021-09-10 13:51',
        location: '中部PDS',
        coordinate: [121.4591572, 25.0571437],
      },
      {
        status: 'expired',
        speed: '0',
        time: '2021-09-10 13:51',
        location: '中部PDS',
        coordinate: [121.4591572, 25.0571437],
      },        
  ];
  let timer = null;


  export default {
    data() {
      return {
        // 因為地圖下方有資訊區塊，為了使marker在畫面中間，故將中心點的緯度偏移0.0005
        mapCenter: fromLonLat([dafaultPosition[0],dafaultPosition[1] - 0.0005]),
        zoom: 16,
        featureCoordinateArr: [],  
        map: null,
        currentCarStatus: {
          status: '',
          speed: '',
          time: '',
          location: '',
        },
        hasUpdatedRecord: true,
        isExpired: false,
        testData: [],
        ws: null,
      }
    },
    mounted() {
      this.initiateMap();

      // if ("WebSocket" in window) this.establishWebSocket();
      // else {
      //   console.log("broswer is not support webSocket");  
      // }
      // this.establishSocketIo();
    },
    methods: {
      initiateMap() {
        this.map = new Map({
          target: "map",
          layers: [tileLayer],
          view: this.view,
          controls: defaults({
            zoom: false, // 關閉左上角的縮放按鈕控件
          }),
          interactions: defaultInteractions({
            pinchRotate: false // 移動端禁止地圖旋轉
          }),
        });

        for (const data of testData) {
          const index = testData.indexOf(data);
          const element = testData[index];

          // 假資料，測試監控地圖資料變動
          timer = setTimeout(() => {
            this.map.removeLayer(this.pointsLayer);
            this.map.getView().setCenter(fromLonLat([element.coordinate[0], element.coordinate[1] - 0.0005]));
            this.featureCoordinateArr = element.coordinate;
            this.currentCarStatus = {
              status: element.status,
              speed: element.speed,
              time: element.time,
              location: element.location,
            }
            this.hasUpdatedRecord = element.status === 'noData' ? false : true;
            this.isExpired = element.status === 'expired' ? true : false;
            this.map.addLayer(this.pointsLayer);

          }, index * 5000);
        }      
      },
      // establishWebSocket() {
      //   let ws = new WebSocket('ws://localhost:5000');

      //   ws.onopen = function () {
      //       console.log('connect is open');
      //   };
      //   // 接收server傳過來的數據
      //   ws.onmessage = e => {
      //     console.log('data', JSON.parse(e.data));
      //     this.testData = [...this.testData, JSON.parse(e.data)];
      //   };
      //   // 連接錯誤
      //   ws.onerror = function () {
      //       console.log('connect is error');
      //   }
      //   // 連接關閉
      //   ws.onclose = function () {
      //       console.log("connect is closed");
      //   }
      // },
      // establishSocketIo () {
      //   this.ws = io("ws://localhost:4040");

      //   this.ws.on('getMonitorMapCarStatus', message => {
      //     console.log(JSON.parse(message));
      //     this.testData = [...this.testData, JSON.parse(message)];
      //   })
      // },
    },
    computed: {
      // 設定地圖的視圖
      view: function() {
        return new View({
          center: fromLonLat(this.mapCenter),
          zoom: this.zoom,
          minZoom: 6,
          maxZoom: 18,
          extent: transformExtent(extentBound, 'EPSG:4326', 'EPSG:3857'),        
        })
      },
      // 以向量的方式新增一個向量的數據來源
      vectorSource: function() {
        // 以點(point)的方式新增要素(feature)
        const tmpFeature = new Feature({
            geometry: new Point(fromLonLat(this.featureCoordinateArr)),
            name: 'marker',
          });
        // 將要素放到數據來源(source)裡面
        return new Vector({
          features: [tmpFeature],
          format: new GeoJSON(),
        })
      },    
      // 用向量新增一個圖層，用來標示目前所在位置的marker
      // 一層layer裡面，要有一個數據來源source，而source包含了很多地理要素features
      pointsLayer: function() {
        const layer = new VectorLayer({
          source: this.vectorSource,
          style: () => {
            let style = null;

            switch (this.currentCarStatus.status) {
              case 'driving':
                style = drivingMarkerStyle;
                break;
              case 'flameout':
                style = flameoutMarkerStyle;
                break;              
              case 'lost':
                style = lostMarkerStyle;
                break;
              case 'idle':
                style = idleMarkerStyle;
                break;
              default:
                break;
            }
            return style;
          }
        });

        return layer;
      },
      carStatusText: function() {
        let text = '';

        switch (this.currentCarStatus.status) {
          case 'driving':
            text = '行駛中';
            break;
          case 'flameout':
            text = '熄火';
            break;              
          case 'lost':
            text = '失聯';
            break;
          case 'idle':
            text = '怠速中';
            break;
          default:
            text = '--';
            break;
        }
        return text;
      },
    },
    // watch: {
    //   testData: function() {
    //     for (const data of this.testData) {
    //         this.map.removeLayer(this.pointsLayer);
    //         this.map.getView().setCenter(fromLonLat([data.coordinate[0], data.coordinate[1] - 0.0005]));
    //         this.featureCoordinateArr = data.coordinate;
    //         this.currentCarStatus = {
    //           status: data.status,
    //           speed: data.speed,
    //           time: data.time,
    //           location: data.location,
    //         }
    //         this.hasUpdatedRecord = data.status === 'noData' ? false : true;
    //         this.isExpired = data.status === 'expired' ? true : false;
    //         this.map.addLayer(this.pointsLayer);
    //     }
    //   },
    // },
    beforeDestroy() {
      clearTimeout(timer);
      // this.ws.disconnect();
    },
  };
</script>

<style scoped lang="scss">
  @import "../../assets/scss/global.scss";
  @import "../../../node_modules/ol/ol.css";
  .map_container {
    height: calc(100vh - 80px);
    #map {
        position: absolute;
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        z-index: 1;
        background-color: rgb(163, 203, 255);
      }
      ul {
        list-style: none;
        padding: 11px 14px;
        margin: 0;
        width: 94%;
        height: 100px;
        background: #FFFF;
        bottom: 0;
        position: fixed;
        z-index: 2;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 8px 8px 0 0;
        box-shadow: 0px 0px 0.8px rgb(0 0 0 / 6%), 0px 0px 2px rgb(0 0 0 / 4%), 0px 0px 5px rgb(0 0 0 / 4%), 0px 0px 17px rgb(0 0 0 / 3%);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        li {
          color: #343741;
          font-size: 14px;
          line-height: 24px;
          font-weight: 500;
          display: flex;
          align-items: center;
          .map_info_icon {
            width: 22px;
            height: 22px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 12px;
          }
          span {
            display: inline-block;
            margin-right: 10px;
          }
        }
      }

      .expired_btn {
        position: absolute;
        z-index: 2;
        border-radius: 6px;
        border: transparent;
        padding: 12px;
        background-color: #FFFF;
        box-shadow: 0px 2.7px 9px rgba(0, 0, 0, 0.13), 0px 9.4px 24px rgba(0, 0, 0, 0.09), 0px 21.8px 43px rgba(0, 0, 0, 0.08);
        color: #F10000;
        left: 50%;
        top: 24px;
        transform: translateX(-50%);
        font-size: 16px;
        line-height: 24px;
        width: 70%;
      }

      .no_record_btn {
        position: absolute;
        z-index: 2;
        border-radius: 6px;
        border: transparent;
        padding: 12px;
        background-color: #FFFF;
        box-shadow: 0px 2.7px 9px rgba(0, 0, 0, 0.13), 0px 9.4px 24px rgba(0, 0, 0, 0.09), 0px 21.8px 43px rgba(0, 0, 0, 0.08);
        color: #343741;
        left: 50%;
        top: 35%;
        transform: translatex(-50%);
        font-size: 16px;
        line-height: 24px;
        width: 70%;
      }    
  }
  
  
</style>